import React from 'react';
import { cn } from './cn';

export type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  tone?: 'default' | 'soft';
};

export function Card({ className, tone = 'default', ...props }: CardProps) {
  return (
    <div
      {...props}
      className={cn(
        'rounded-2xl border border-surface-border shadow-card',
        tone === 'default' ? 'bg-surface-card/70' : 'bg-surface-card/45',
        className,
      )}
    />
  );
}

